/**
 *
 * UserSetting
 *
 */

import UserSetting from './UserSetting.jsx';
import './UserSetting.less';

export default UserSetting;
